import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    flex: 1,
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  serviceName: {
    flexShrink: 1,
  },
  duration: {
    flexShrink: 0,
  },
  spaceTop: {
    paddingTop: theme.spacing[4],
  },
  timePreferences: {
    paddingTop: theme.spacing[7],
  },
  noAvailabilityIcon: {
    position: 'absolute',
    top: -theme.spacing[3],
    right: -theme.spacing[3],
    backgroundColor: colors.backgroundNegative,
    padding: 6,
    borderRadius: theme.borderRadius.full,
  },
}));
